<template>
  <BillingAdd/>
</template>

<script>
import BillingAdd from "./BillingAdd";

export default {
  name: "BillingEdit",
  components:{
    BillingAdd
  }
}
</script>

<style scoped>

</style>
